import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { LockKey } from "@phosphor-icons/react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#111827] font-admin flex items-center justify-center px-5">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-8">
          <div className="h-11 w-11 rounded-lg bg-[#1F2937] border border-[#374151] flex items-center justify-center">
            <LockKey size={22} weight="bold" className="text-[#F9FAFB]" />
          </div>
          <div>
            <p className="font-mono-kds text-[#F9FAFB] text-sm tracking-widest">GLEDSWOOD KDS</p>
            <p className="text-[#9CA3AF] text-xs">Kitchen Display · Staff Access</p>
          </div>
        </div>

        <form
          onSubmit={submit}
          autoComplete="off"
          className="bg-[#1F2937] border border-[#374151] rounded-xl p-6 space-y-4"
        >
          <div>
            <label className="text-[#9CA3AF] text-xs uppercase tracking-wider">Email</label>
            <input
              data-testid="login-email-input"
              type="email"
              autoComplete="off"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 w-full bg-[#111827] border border-[#374151] rounded-lg px-4 py-3 text-[#F9FAFB] text-sm outline-none focus:ring-2 focus:ring-emerald-500"
              placeholder="admin@gledswood.com.au"
            />
          </div>
          <div>
            <label className="text-[#9CA3AF] text-xs uppercase tracking-wider">Password</label>
            <input
              data-testid="login-password-input"
              type="password"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 w-full bg-[#111827] border border-[#374151] rounded-lg px-4 py-3 text-[#F9FAFB] text-sm outline-none focus:ring-2 focus:ring-emerald-500"
              placeholder="••••••••"
            />
          </div>
          {error && (
            <p data-testid="login-error" className="text-[#EF4444] text-sm">
              {error}
            </p>
          )}
          <button
            data-testid="login-submit-btn"
            disabled={loading}
            className="w-full bg-emerald-600 hover:bg-emerald-500 text-white py-3 rounded-lg font-medium transition-colors disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Enter Kitchen"}
          </button>
        </form>

        <button
          onClick={() => navigate("/")}
          className="mt-6 w-full text-center text-[#9CA3AF] text-sm hover:text-[#F9FAFB] transition-colors"
        >
          ← Back to menu
        </button>
      </div>
    </div>
  );
}
